import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { UIElementsModule } from '../ui-elements/ui-elements.module';
import { allComponents, publicComponents } from './components/index';
import { SimXPreset } from './themes/simx.theme';

const primeNgUiComponents = [DatePickerModule, DialogModule];

@NgModule({
  declarations: [...allComponents],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UIElementsModule,
    ...primeNgUiComponents,
  ],
  providers: [
    providePrimeNG({
      theme: {
        preset: SimXPreset,
        options: {
          darkModeSelector: false,
        },
      },
    }),
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ...primeNgUiComponents,
    ...publicComponents,
  ],
})
export class AppCommonModule {
  private readonly _filterService = inject(FilterService);

  constructor() {
    this.configureFilter();
  }

  private configureFilter() {
    const containsFilter = this._filterService.filters['contains'];
    // register custom filter for contains
    this._filterService.register(
      'contains',
      (value: any, filter: any): boolean => {
        return containsFilter(value, filter.trim());
      },
    );
  }
}
